// actionTypes.js
export const SET_VALUE_Pindu = "SET_VALUE_Pindu";
export const SET_TYPE_Pindu = "SET_TYPE_Pindu";
export const SET_CURRENT_PAGE_Pindu = "SET_CURRENT_PAGE_Pindu";
export const SET_ORDER_Pindu = "SET_ORDER_Pindu";
export const SET_SORT_FIELD_Pindu = "SET_SORT_FIELD_Pindu";
export const SET_ACTIF_Pindu = "SET_ACTIF_Pindu";
